const YOUR_DOMAIN = window.location.origin;
const YOUR_DOMAIN_LENGTH = YOUR_DOMAIN.length;
const SUPPORTED_LANGUAGES = ["de", "en", "nl"];
const LANGUAGE_COOKIE_NAME = "cg_locale";

function getCookie(name) {
  console.log("set_lang::getCookie called!")
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2){ 
    let c = parts.pop().split(';').shift();
    return c;
  }
  else
    return null;
}

function setCookie(cookieValue){
  var cookieName = LANGUAGE_COOKIE_NAME;
  var myDate = new Date();
  myDate.setMonth(myDate.getMonth() + 12);
  
  document.cookie = `${cookieName}=${cookieValue}; expires=${myDate}; domain=${window.location.hostname}; path=/`;
}

function getSelectedLocale(){
  console.log("set_lang::getSelectedLocale called!");
  let currentLocale = null;
  
  if(SUPPORTED_LANGUAGES.includes(Shopify.locale)){
    currentLocale = Shopify.locale;
  }

  return currentLocale;
}

function getUrlLocale() {
  var urlLocale =  window.location.pathname.split("/")[1];

  if(SUPPORTED_LANGUAGES.includes(urlLocale)){
    return urlLocale;
  }
  
  return null;
}

function redirect(_locale) {
  const url = window.location.href;
  const loc = _locale != 'en' ?  `/${_locale}` : ``;
  const redirect_url = window.location.origin + loc + window.location.pathname;
  console.info("set_lang::Redirecting to " + redirect_url);
  
  if(url != redirect_url)
    window.location.href= redirect_url;
}

function setLocale(allowCookie){
  const urlLocale = getUrlLocale();
  const selectedLocale = getSelectedLocale();

  console.info('set_lang::Executing setLocale...');
  const cookieLocale = getCookie(LANGUAGE_COOKIE_NAME);
    
  if (!cookieLocale && !urlLocale) {
    $.getJSON('https://ipapi.co/json/', function(data) {
        var currentLanguage = "en";
        if(SUPPORTED_LANGUAGES.includes(data.country_code.toLowerCase()))
          currentLanguage = data.country_code.toLowerCase();
        else
          currentLanguage = "en";        
  
        if(selectedLocale != currentLanguage && SUPPORTED_LANGUAGES.includes(currentLanguage)){
          if(allowCookie)
            setCookie(currentLanguage);
          else
            console.info('set_lang::Consent is not set!');

          console.info("set_lang::setLocale step1");
          redirect(currentLanguage);
        }
      });
  }else if (!urlLocale && allowCookie && cookieLocale && selectedLocale != cookieLocale && SUPPORTED_LANGUAGES.includes(cookieLocale)) {
        console.info("set_lang::setLocale step2");
        redirect(cookieLocale);
  }else{
      console.info('set_lang::setLocale nothing to do!')
  }
}

window.Shopify.loadFeatures([
    {
      name: 'consent-tracking-api',
      version: '0.1',
    }
  ],
  function(error) {
    if (error) {
      throw error;
    }

    setLocale(window.Shopify.customerPrivacy.preferencesProcessingAllowed());
});

